app.factory("sharedDataRegionService", function() {
    var _logData = null;
    var _userInfo = null;
    var _gradeScore = 0;
    var _answerHistory = null;
    var _balanceOdmResult = {
        "score"   : 0,
        "message" : ""
    };
    var _medicalList = null;
    return {
        setUserInfo : function(userinfo) {
            _userInfo = userinfo;
        },
        getUserInfo : function() {
            return _userInfo;
        },
        setLogData : function(logdata) {
            _logData = logdata;
        },
        getLogData : function() {
            return _logData;
        },
        setMedicalList : function(loglist) {
            _medicalList = loglist;
        },
        getMedicalList : function() {
            return _medicalList;
        },
        setGradeScore : function(score) {
            _gradeScore = score;
        },
        getGradeScore : function() {
            return _gradeScore;
        },
        setAnswerHistory : function(answerHistory) {
            _answerHistory = answerHistory;
        },
        getAnswerHistory : function() {
            return _answerHistory;
        },
        setBalanceOdmResult : function(score, message, image) {
            _balanceOdmResult = {
                "score" : score,
                "message" : message,
                "image" : image
            }
        },
        getBalanceOdmResult : function() {
            return _balanceOdmResult;
        },
	};
});
